<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer012">
<p class="part-title-invisible" id="_idParaDest-2"><a id="_idTextAnchor001"></a> </p>
<p class="extract-flush-left"><em class="italic">This above all, to thine own self be true.</em></p>
<p class="extract-right-space-after">—William Shakespeare, <em class="italic">Hamlet</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HowMidsummerNight-2.vue?d32e1510